<div class="mc-view-overview">
  <div class="view-single-column">
      <div class="info-column">
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Status' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-device-status [device]="device"></app-card-device-status>
              </div>
          </div>
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_DeviceDetails' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-device-details [device]="device"></app-card-device-details>
              </div>
          </div>
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Memory' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-memory [device]="device"></app-card-memory>
              </div>
          </div>
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Storage' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-storage [device]="device"></app-card-storage>
              </div>
          </div>
      </div>
  </div>

  <div class="view-double-column">
      <div class="info-column">
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Status' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-device-status [device]="device"></app-card-device-status>
              </div>
          </div>
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Memory' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-memory [device]="device"></app-card-memory>
              </div>
          </div>
      </div>
      <div class="info-column">
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_DeviceDetails' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-device-details [device]="device"></app-card-device-details>
              </div>
          </div>
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Storage' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-storage [device]="device"></app-card-storage>
              </div>
          </div>
      </div>
  </div>

  <div class="view-triple-column">
      <div class="info-column">
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Status' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-device-status [device]="device"></app-card-device-status>
              </div>
          </div>
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Storage' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-storage [device]="device"></app-card-storage>
              </div>
          </div>
      </div>
      <div class="info-column">
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_DeviceDetails' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-device-details [device]="device"></app-card-device-details>
              </div>
          </div>
      </div>
      <div class="info-column">
          <div class="info-box">
              <div class="box-header">
                  <div class="box-title"><span>{{'label_Memory' | xsI18n}}</span></div>
              </div>
              <div class="box-body">
                  <app-card-memory [device]="device"></app-card-memory>
              </div>
          </div>
      </div>
  </div>
</div>
